import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Globals } from 'src/app/globals';
import { AvailibilityService } from 'src/app/services/availibility.service';
// Services
import { BasketService, DataStoreService } from '../../services';
import { environment } from '../../../environments/environment';

declare var RealexHpp: any;

@Component({
  selector: 'app-tncs',
  templateUrl: './tncs.component.html',
  styleUrls: ['./tncs.component.css']
})
export class TncsComponent implements OnInit {

  tncForm: FormGroup;
  submitted = false;
  applicationDetails;
  selectedService;
  globals: Globals;
  slotsInPast = false;
  slotsInvalid = false;
  @ViewChild("error") errorElement: ElementRef;

  constructor(
    private router: Router,
    private DataStore: DataStoreService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private http: HttpClient,
    private availibilityService: AvailibilityService,
    private basketService: BasketService,
    private _cookieService: CookieService,
    globals: Globals,
  ) {
    this.globals = globals;
  }

  tncsText;
  tncsTextIrish;
  applicantArray;
  serviceTotal;
  @ViewChild('paymentButton') paymentButton: ElementRef<HTMLElement>;

  linkClicked(ev) {
    if (ev.target.href) {
      console.log(ev.target.href);
      window.open(ev.target.href, '_blank').focus();
      ev.preventDefault();
    }
  }

  ngOnInit() {
    this.tncForm = this.formBuilder.group({
      tncCB: [false, Validators.requiredTrue]
    });

    if (this.DataStore.selectedLocation) {
      // Redirect the elavons payment portal
      RealexHpp.setHppUrl(environment.elavonURL);

      this.applicantArray = this.DataStore.applicantArrayCopy;
      this.selectedService = this.DataStore.selectedService;
      this.serviceTotal = this.DataStore.serviceTotal;

      this.tncsText = '';
      this.tncsTextIrish = '';

      const extraQuestions = this.DataStore.selectedService.extra;
      for (const key in extraQuestions) {
        if (extraQuestions.hasOwnProperty(key)) {
          const element = extraQuestions[key];

          if (key.toLowerCase().indexOf('terms_and_conditions') >= 0) {
            if (!this.tncsText) {
              this.tncsText += element;
            } else {
              this.tncsText += ' ' + element;
            }
          } else if (key.toLowerCase().indexOf('t_cs_irish_text') >= 0) {
            if (!this.tncsTextIrish) {
              this.tncsTextIrish += element;
            } else {
              this.tncsTextIrish += ' ' + element;
            }
          }
        }
      }
    } else {
      // Made it a function as back btn uses it too
      this.routerGoBack();
    }
  }

  // scroll to the first invalid control on page
  scrollToError() {
    this.errorElement.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }

  routerGoBack() {
    this.router.navigate(['/checklist']);
  }

  // Getter for easy access to form fields
  get form() { return this.tncForm.controls; }

  proceed() {
    this.spinner.show();
    this.submitted = true;
    this.tncForm.markAllAsTouched();

    // Check if the users selected slots are still valid (not in the past). If the selected slot is 
    // now in the past then display error message and stop them from proceeding
    this.DataStore.basketItems.forEach(async item => {
      const now = new Date();
      const selectedStart = new Date(item.start);
      if (now >= selectedStart) {
        this.slotsInPast = true;
      }
    });

    if (this.tncForm.invalid || this.slotsInPast) {
      this.spinner.hide();
      this.scrollToError();
      return;
    }

    this.DataStore.selectedLocation.$post('client', {}, {
      first_name: this.DataStore.clientDetails.forenameOne,
      last_name: this.DataStore.clientDetails.surname,
      email: this.DataStore.clientDetails.email,
      mobile: `${this.DataStore.clientDetails.telephonePrefix}${this.DataStore.clientDetails.telephone}`,
      mobile_prefix_country_code: this.DataStore.countryDetails ? this.DataStore.countryDetails.iso2 ?
        this.DataStore.countryDetails.iso2.toUpperCase() : '' : '',
      client_type: 'contact'
    }).then(async clientRes => {
      let noNotifications;

      if (this.DataStore.selectedService.price > 0) {
        noNotifications = true;
      } else {
        noNotifications = false;
      }

      await this.basketService.checkoutBasket(clientRes, noNotifications).then((res) => {
        this.DataStore.checkoutData = res;
        this.DataStore.purchase = res;
        this.DataStore.client = clientRes;

        this.router.navigate(['/payment']);
      }).catch((error: HttpErrorResponse) => {
        if (error['response'].status === 409) {
          this.slotsInvalid = true;
          this.spinner.hide();
        }
      });
    });
  }
}
